import _slicedToArray from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.from-entries.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/markus/Coding/GitHub/sailing/node_modules/@babel/runtime/regenerator";
export default function sqlite(_x) {
  return _sqlite.apply(this, arguments);
}

function _sqlite() {
  _sqlite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(require) {
    var sql;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return require("sql.js@1.5.0/dist/sql-wasm.js");

          case 2:
            sql = _context5.sent;
            return _context5.abrupt("return", sql({
              locateFile: function locateFile(file) {
                return "https://cdn.jsdelivr.net/npm/sql.js@1.5.0/dist/".concat(file);
              }
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _sqlite.apply(this, arguments);
}

export var SQLiteDatabaseClient = /*#__PURE__*/function () {
  function SQLiteDatabaseClient(db) {
    _classCallCheck(this, SQLiteDatabaseClient);

    Object.defineProperties(this, {
      _db: {
        value: db
      }
    });
  }

  _createClass(SQLiteDatabaseClient, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_query, params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return exec(this._db, _query, params);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function query(_x2, _x3) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }, {
    key: "queryRow",
    value: function () {
      var _queryRow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.query(query, params);

              case 2:
                _context2.t0 = _context2.sent[0];

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.t0 = null;

              case 5:
                return _context2.abrupt("return", _context2.t0);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function queryRow(_x4, _x5) {
        return _queryRow.apply(this, arguments);
      }

      return queryRow;
    }()
  }, {
    key: "explain",
    value: function () {
      var _explain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query, params) {
        var rows;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.query("EXPLAIN QUERY PLAN ".concat(query), params);

              case 2:
                rows = _context3.sent;
                return _context3.abrupt("return", element("pre", {
                  className: "observablehq--inspect"
                }, [text(rows.map(function (row) {
                  return row.detail;
                }).join("\n"))]));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function explain(_x6, _x7) {
        return _explain.apply(this, arguments);
      }

      return explain;
    }()
  }, {
    key: "describe",
    value: function () {
      var _describe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(object) {
        var rows, columns;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return object === undefined ? this.query("SELECT name FROM sqlite_master WHERE type = 'table'") : this.query("SELECT * FROM pragma_table_info(?)", [object]);

              case 2:
                rows = _context4.sent;

                if (rows.length) {
                  _context4.next = 5;
                  break;
                }

                throw new Error("Not found");

              case 5:
                columns = rows.columns;
                return _context4.abrupt("return", element("table", {
                  value: rows
                }, [element("thead", [element("tr", columns.map(function (c) {
                  return element("th", [text(c)]);
                }))]), element("tbody", rows.map(function (r) {
                  return element("tr", columns.map(function (c) {
                    return element("td", [text(r[c])]);
                  }));
                }))]));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function describe(_x8) {
        return _describe.apply(this, arguments);
      }

      return describe;
    }()
  }]);

  return SQLiteDatabaseClient;
}();

function exec(_x9, _x10, _x11) {
  return _exec.apply(this, arguments);
}

function _exec() {
  _exec = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(db, query, params) {
    var _yield$db$exec, _yield$db$exec2, result, columns, values, rows;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return db.exec(query, params);

          case 2:
            _yield$db$exec = _context6.sent;
            _yield$db$exec2 = _slicedToArray(_yield$db$exec, 1);
            result = _yield$db$exec2[0];

            if (result) {
              _context6.next = 7;
              break;
            }

            return _context6.abrupt("return", []);

          case 7:
            columns = result.columns, values = result.values;
            rows = values.map(function (row) {
              return Object.fromEntries(row.map(function (value, i) {
                return [columns[i], value];
              }));
            });
            rows.columns = columns;
            return _context6.abrupt("return", rows);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _exec.apply(this, arguments);
}

function element(name, props, children) {
  if (arguments.length === 2) children = props, props = undefined;
  var element = document.createElement(name);
  if (props !== undefined) for (var p in props) {
    element[p] = props[p];
  }

  if (children !== undefined) {
    var _iterator = _createForOfIteratorHelper(children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var c = _step.value;
        element.appendChild(c);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return element;
}

function text(value) {
  return document.createTextNode(value);
}